import React, { useEffect, useRef, useState } from 'react';
import Modal from 'react-modal';
import FullCalendar from '@fullcalendar/react';
import dayGridPlugin from '@fullcalendar/daygrid';
import timeGridPlugin from '@fullcalendar/timegrid';
import interactionPlugin from '@fullcalendar/interaction';
import {
  format,
  subDays,
  addDays,
  compareAsc,
  differenceInMinutes,
} from 'date-fns';

import CloseIcon from '../../components/svg/closeIcon';
import LeftArrow from '../../components/svg/leftArrow';
import RightArrow from '../../components/svg/rightArrow';
import { createCounsellorAvailableSlots, deleteAvailabilitySlot, getAvailableSlot, getTecoAdviceUserAgreement, saveUserAgrementResposne } from '../../modals';
import UserAgreementDialog from '../../settings/userAgreementDialog';
function debounce(func, wait) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => func(...args), wait);
  };
}
const customStyles = {
  content: {
    top: '50%',
    left: '50%',
    right: 'auto',
    bottom: 'auto',
    marginRight: '-50%',
    transform: 'translate(-50%, -50%)',
    minWidth: '400px',
    padding: '30px',
    borderRadius: '25px',
    maxWidth: '93%',
  },

  overlay: {
    position: 'fixed',
    top: 0,
    left: 0,
    right: 0,
    bottom: 0,
    backgroundColor: 'rgba(0, 0, 0, 0.5)',
    zIndex: '10',
  },
};
Modal.setAppElement(document.getElementById('root'));

function CalendarModal({
  show,
  showHideModal,
  editable = false,
  navigationAllowed = false,
  firstTime = false,
  viewOnly = false,
  skipWeeks = false,
}) {
  const [showAgreement, setShowAgreement] = useState(false);
  const [agreeMentData, setAgreeMentData] = useState(false);
  const [loading, setLoading] = useState(true);
  const USER_INFO = { ...JSON.parse(localStorage.getItem('userinfo')) };
  const [headerMonths, setHeaderMonths] = useState({});
  const { nextMonth, prevMonth, nextDate, prevDate } = headerMonths;
  const [meetingsArray, setMeetingsArray] = useState([]);
  const [meetingData, setMeetingData] = useState([]);
  const [navigationState, setNavigationState] = useState({});
  const { prevClicked = true, nextClicked = false } = navigationState;
  const [calendarStartDate, setCalendarStartDate] = useState('');
  const { calStartDate, calStartFlag } = calendarStartDate;
  const [currentWeekRange, setCurrentWeekRange] = useState({});
  const { currentStart, currentEnd } = currentWeekRange;
  const [localCaId, setLocalCaId] = useState(1);
  const calendarRef = useRef();
  const [apiResponse, setApiResponse] = useState('');
  const [saving, setSaving] = useState(false);
  const [endDateReached, setEndDateReached] = useState(false);
  const [juneEndReached, setJuneEndReached] = useState(false);
  const [showDeleteConfirm, setShowDeleteConfirm] = useState(false);
  const [eventToDelete, setEventToDelete] = useState(null);
  const [eventLocalCaId, setEventLocalCaId] = useState(null);
  const renderHeaderDates = (args) => {
    // Check if this date is today
    const isToday = format(args.date, 'yyyy-MM-dd') === format(new Date(), 'yyyy-MM-dd');

    return (
      <div style={{
        display: 'flex',
        flexDirection: 'column',
        fontWeight: isToday ? 'bold' : 'normal' // Make today's text bold
      }}>
        <span>{format(args.date, 'EEEE')}</span>
        <span>{format(args.date, 'd')}</span>
      </div>
    );
  };
  const removeTempEvents = () => {
    const calendarApi = calendarRef.current.getApi();
    if (calendarApi.getEventById('new')) {
      calendarApi.getEventById('new').remove();
    }
    if (calendarApi.getEventById('new')) {
      removeTempEvents();
    }
  };
  const createMeetingArray = (data, reset = false) => {
    let meetingarr = [];
    if (data.length > 0) {
      data.map((item) => {
        const { start, end, date, caId, title } = item;
        meetingarr.push({
          start: `${date}T${start}`,
          end: `${date}T${end}`,
          id: caId,
          title,
        });
      });
    }
    setMeetingsArray(meetingarr);
    reset && removeTempEvents();
  };
  const handleDateSelect = (selectInfo) => {
    let date = format(selectInfo.start, 'yyyy-MM-dd');
    let startDay = format(selectInfo.start, 'EEEE');
    let endDay = format(selectInfo.end, 'EEEE');
    let calendarApi = selectInfo.view.calendar;
    if (startDay !== endDay) {
      calendarApi.unselect();
      alert("Can't select more than one day");
      return false;
    }
    if (compareAsc(selectInfo.start, new Date()) === -1) {
      calendarApi.unselect();
      alert("Can't select past days or past hours");
      return false;
    }

    // let title = prompt('Please enter a new title for your event');
    calendarApi.unselect(); // clear date selection
    let localcaid = localCaId;
    calendarApi.addEvent({
      localCaId: localCaId,
      id: 'new',
      title: 'Available',
      start: selectInfo.startStr,
      end: selectInfo.endStr,
      allDay: selectInfo.allDay,
    });
    let data = [
      ...meetingData,
      {
        localCaId: localCaId,
        caId: null,
        collegeId: USER_INFO.schoolId,
        counselorId: USER_INFO.id,
        availableDate: date,
        startTime: format(selectInfo.start, 'HH:mm:ss'),
        endTime: format(selectInfo.end, 'HH:mm:ss'),
      },
    ];
    setLocalCaId(localcaid + 1);
    setMeetingData(data);
  };

  const handleDeleteClick = () => {
    setShowDeleteConfirm(true);
  };

  const handleDeleteEvent = async (eventId, localCaId) => {
    let updatedData = [...meetingData];
    if (eventId === 'new') {
      updatedData = updatedData.filter(item => item.localCaId !== localCaId);
      setMeetingData(updatedData);
      const calendarApi = calendarRef.current.getApi();
      const events = calendarApi.getEvents();
      const eventToRemove = events.find(e => e.extendedProps?.localCaId === localCaId);
      if (eventToRemove) {
        eventToRemove.remove();
      }
    } else {
      try {
        const result = await deleteAvailabilitySlot(eventId);
        if (result.length) {
          alert("Please cancel the meeting associated with this slot before deleting it.");

        }
        const calendarApi = calendarRef.current.getApi();

        const from = format(calendarApi.getDate(), 'yyyy-MM-dd');
        const to = format(addDays(calendarApi.getDate(), 6), 'yyyy-MM-dd');
        loadAvailableSlot({
          collegeId: USER_INFO.schoolId,
          counselorId: USER_INFO.id,
          fromDate: from,
          toDate: to,
        });

      } catch (error) {
        alert("Please cancel the meeting associated with this slot before deleting it.");

      }
    }

  };
  const renderEventContent = ({ event: { start, end, title, id, extendedProps } }) => {
    const difference = differenceInMinutes(end, start);
    const starttime = format(start, 'hh:mm a');
    const endtime = format(end, 'hh:mm a');
    const localCaId = extendedProps?.localCaId;
    return (
      <div style={{ display: 'flex', gap: '6px', alignItems: 'center', justifyContent: 'space-between', width: '100%' }}>
        <div>
          <p style={{ fontWeight: '400', fontSize: '12px', margin: '0' }}>
            {title}
            <span style={{ fontWeight: '400', fontSize: '10px' }}>
              {difference <= 30 && ' ' + starttime + ' - ' + endtime}
            </span>
          </p>
          {difference > 30 && (
            <p style={{ fontWeight: '400', fontSize: '12px', margin: '0' }}>
              {starttime + ' - ' + endtime}
            </p>
          )}
        </div>
        {!viewOnly && (
          <button
            onClick={(e) => {
              e.stopPropagation();
              setEventToDelete(id);
              setEventLocalCaId(localCaId);
              setShowDeleteConfirm(true);
            }}
            style={{
              background: 'none',
              border: 'none',
              cursor: 'pointer',
              padding: '2px',
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
            }}
            title="Delete event"
          >
            <svg
              width="16"
              height="16"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            >
              <polyline points="3 6 5 6 21 6"></polyline>
              <path d="M19 6v14a2 2 0 0 1-2 2H7a2 2 0 0 1-2-2V6m3 0V4a2 2 0 0 1 2-2h4a2 2 0 0 1 2 2v2"></path>
              <line x1="10" y1="11" x2="10" y2="17"></line>
              <line x1="14" y1="11" x2="14" y2="17"></line>
            </svg>
          </button>
        )}
      </div>
    );
  };
  const getEndDateLimit = () => {
    const today = new Date(); // Get the current date
    const currentMonth = today.getMonth(); // Get the current month (0-indexed)
    const currentDate = today.getDate(); // Get the current day of the month

    // If current date is December 1 or later
    if (currentMonth === 11 && currentDate >= 1) { // December
      // Use June 30th of the next year as limit
      return new Date(today.getFullYear() + 1, 5, 30); // June 30th of next year
    }

    // If current date is between June 1 and December 1
    if ((currentMonth === 5 && currentDate >= 1) || // June
      (currentMonth > 5 && currentMonth < 11) || // July through November
      (currentMonth === 11 && currentDate < 1)) { // Before December 1
      // Use December 31st as limit
      return new Date(today.getFullYear(), 11, 31); // December 31st
    }
    // If current date is between January 1 and before June 1
    else if ((currentMonth >= 0 && currentMonth < 5) || // January through May
      (currentMonth === 5 && currentDate < 1)) { // Before June 1
      // Use June 30th as limit
      return new Date(today.getFullYear(), 5, 30); // June 30th
    }

    // Default fallback
    return new Date(today.getFullYear(), 5, 30); // June 30th
  };
  const isDateBeyondLimit = (date) => {
    const endDateLimit = getEndDateLimit();

    // Create a new date object for the end date and set it to the end of the day
    const endOfDay = new Date(endDateLimit);
    endOfDay.setHours(23, 59, 59, 999);

    // Compare with the end of the day to allow selection on the end date
    return date > endOfDay;
  };
  const preventSlotBeforeStartTime = ({ start, end }) => {
    const slotmax = new Date(format(start, 'yyyy-MM-dd'));
    const slotmin = 6;
    slotmax.setHours(23);
    slotmax.setMinutes(0);

    // Check if the date is beyond the end limit (but allow the end date itself)
    if (isDateBeyondLimit(start)) {
      return false;
    }

    if (parseInt(format(start, 'H')) < slotmin) return false;
    if (
      compareAsc(end, slotmax) === 1 ||
      parseInt(format(start, 'H')) > parseInt(format(end, 'H'))
    ) {
      return false;
    }
    return true;
  };
  // Debounced calendar navigation to prevent rapid consecutive calls
  const calendarNavigation = debounce((direction) => {
    const calendarApi = calendarRef.current.getApi();

    if (!(endDateReached && direction === 'next')) {
      direction === 'prev' && calendarApi.prev();
      direction === 'next' && calendarApi.next();
    }

    const prevMonth = format(calendarApi.getDate(), 'MMMM');
    const nextMonth = format(addDays(calendarApi.getDate(), 6), 'MMMM');
    const prevDate = format(calendarApi.getDate(), 'dd');
    const nextDate = format(addDays(calendarApi.getDate(), 6), 'dd');
    setHeaderMonths({ nextMonth, prevMonth, prevDate, nextDate });

    if (calStartDate === format(calendarApi.getDate(), 'yyyy-MM-dd')) {
      setCalendarStartDate({ ...calendarStartDate, calStartFlag: true });
    } else {
      setCalendarStartDate({ ...calendarStartDate, calStartFlag: false });
    }

    const from = format(calendarApi.getDate(), 'yyyy-MM-dd');
    const to = format(addDays(calendarApi.getDate(), 6), 'yyyy-MM-dd');

    const fromDate = new Date(from);
    const toDate = new Date(to);

    const isEndDateInRange = checkForEndDate(fromDate, toDate);

    setEndDateReached(isEndDateInRange);

    setCurrentWeekRange({
      currentStart: from,
      currentEnd: to,
    });
    loadAvailableSlot({
      collegeId: USER_INFO.schoolId,
      counselorId: USER_INFO.id,
      fromDate: from,
      toDate: to,
    });
  }, 400); // 400ms debounce
  const loadAvailableSlot = async (data, reset = false) => {
    try {
      const result = await getAvailableSlot(data);
      const mdata = [];
      result.map(({ date, availableSlot }) => {
        let formateddate = format(new Date(date), 'yyyy-MM-dd');
        availableSlot.map(({ startTime, endTime, caId }) => {
          mdata.push({
            title: 'Available',
            start: startTime.split(':')[0] + ':' + startTime.split(':')[1],
            end: endTime.split(':')[0] + ':' + endTime.split(':')[1],
            date: formateddate,
            caId,
          });
        });
      });

      createMeetingArray(mdata, reset);
    } catch (error) {
      console.log('get available slots', error);
    }
  };
  const createSlot = async () => {
    setSaving(true);
    try {
      let data = [];
      meetingData.map((item) => {
        delete item.localCaId;
        data.push(item);
      });

      await createCounsellorAvailableSlots(meetingData);
      setSaving(false);
      setApiResponse('Availability set successfully!!!');
      setTimeout(() => {
        setApiResponse('');
      }, 5000);
      setMeetingData([]);
      loadAvailableSlot(
        {
          collegeId: USER_INFO.schoolId,
          counselorId: USER_INFO.id,
          fromDate: currentStart,
          toDate: currentEnd,
        },
        true
      );
    } catch (error) {
      setSaving(false);
      setApiResponse(error?.message || 'Something went wrong!');
      console.log('create slot', error);
      setTimeout(() => {
        setApiResponse('');
      }, 5000);
    }
  };
  const editMeeting = ({
    event: {
      start,
      end,
      id,
      extendedProps: { localCaId },
    },
  }) => {
    let data = [...meetingData];
    if (id === 'new') {
      const index = meetingData.findIndex(
        (i) => parseInt(i.localCaId) === parseInt(localCaId)
      );
      if (index > -1) {
        data.splice(index, 1);
      }
    } else {
      const index = meetingData.findIndex(
        (i) => parseInt(i.caId) === parseInt(id)
      );
      if (index > -1) {
        data.splice(index, 1);
      }
    }
    data.push({
      localCaId: localCaId || null,
      caId: id === 'new' ? null : id,
      collegeId: USER_INFO.schoolId,
      counselorId: USER_INFO.id,
      availableDate: format(start, 'yyyy-MM-dd'),
      startTime: format(start, 'HH:mm:ss'),
      endTime: format(end, 'HH:mm:ss'),
    });
    setMeetingData(data);
  };

  const checkForEndDate = (startDate, endDate) => {
    const endDateLimit = getEndDateLimit();
    const endMonth = endDateLimit.getMonth();
    const endDay = endDateLimit.getDate();

    // For debugging

    // Check if any date in the range is the end date
    for (let day = new Date(startDate); day <= endDate; day.setDate(day.getDate() + 1)) {
      if (day.getMonth() === endMonth && day.getDate() === endDay) {
        // Update the header to show the end date
        setHeaderMonths({
          nextMonth: format(endDateLimit, 'MMMM'),
          prevMonth: format(startDate, 'MMMM'),
          nextDate: format(endDateLimit, 'dd'),
          prevDate: format(startDate, 'dd'),
        });

        // Return true to indicate we've reached the end date, but don't block selection
        return true;
      }
    }

    // Check if we've passed the end date
    const endOfDay = new Date(endDateLimit);
    endOfDay.setHours(23, 59, 59, 999);

    if (startDate > endOfDay) {
      return true;
    }

    return false;
  };
  const handleDayCellDidMount = (info) => {
    // Check if this is today's date
    const isToday = format(info.date, 'yyyy-MM-dd') === format(new Date(), 'yyyy-MM-dd');

    if (isToday) {
      // Find the inner cell element with class fc-scrollgrid-sync-inner
      const innerCell = info.el.querySelector('.fc-scrollgrid-sync-inner');
      if (innerCell) {
        // Apply background color to the entire cell
        innerCell.style.backgroundColor = '#caf0f8';


      }
    }
  };
  const updateUserAgreementResponse = async () => {
    try {
      await saveUserAgrementResposne([{
        agreementId: agreeMentData[0]?.tecoUserAgreement?.tuaId,
        isAgreed: 1,
      }]);
      setShowAgreement(false);
      setAgreeMentData(false);
    } catch (error) { }
  };
  useEffect(() => {
    if (loading || agreeMentData || !calendarRef) {
      return;
    }
    const todaysWeek = new Date().getDay();
    const difference = 7 - todaysWeek;
    let calendarStartDate;
    if (skipWeeks) {
      calendarStartDate = addDays(new Date(), difference + 7);
    } else {
      calendarStartDate = subDays(new Date(), todaysWeek);
    }
    setCalendarStartDate({
      calStartDate: format(calendarStartDate, 'yyyy-MM-dd'),
      calStartFlag: true,
    });

    const nextMonth = format(addDays(calendarStartDate, 6), 'MMMM');
    const nextDate = format(addDays(calendarStartDate, 6), 'dd');
    const prevMonth = format(calendarStartDate, 'MMMM');
    const prevDate = format(calendarStartDate, 'dd');
    setHeaderMonths({ nextMonth, prevMonth, nextDate, prevDate });

    const from = format(calendarStartDate, 'yyyy-MM-dd');
    const to = format(addDays(calendarStartDate, 6), 'yyyy-MM-dd');
    setCurrentWeekRange({
      currentStart: from,
      currentEnd: to,
    });
    const fromDate = new Date(from);
    const toDate = new Date(to);

    const isEndDateInRange = checkForEndDate(fromDate, toDate);

    setEndDateReached(isEndDateInRange);

    !firstTime &&
      loadAvailableSlot({
        collegeId: USER_INFO.schoolId,
        counselorId: USER_INFO.id,
        fromDate: from,
        toDate: to,
      });
    setTimeout(() => {
      if (loading || agreeMentData || !calendarRef) {
        return;
      }
      const calendarApi = calendarRef.current.getApi();
      calendarApi.gotoDate(calendarStartDate);
      let timezonediv = document.getElementsByClassName(
        'fc-timegrid-axis-frame'
      )[0];
      timezonediv.innerHTML += '<span class="timezone-calendar">PDT<span>';
    }, 10);
  }, [loading, agreeMentData, calendarRef]);

  // Also add a useEffect to inject custom CSS
  useEffect(() => {
    if (loading || agreeMentData || !calendarRef) {
      return;
    }
    // Add custom CSS to style the header cells
    const style = document.createElement('style');
    style.textContent = `
      .fc-col-header-cell.fc-day-today .fc-scrollgrid-sync-inner {
        background-color: #caf0f8 !important;
      
      }
    `;
    document.head.appendChild(style);

    // Clean up when component unmounts
    return () => {
      document.head.removeChild(style);
    };
  }, [loading, agreeMentData, calendarRef]);
  useEffect(() => {
    getTecoAdviceUserAgreement().then((result) => {
      if (!result[0]?.status) {
        setAgreeMentData(result);
        setShowAgreement(true);
      }
      setLoading(false);
    });
  }, []);
  if (loading) {
    return "";
  }
  if (agreeMentData) {
    return <UserAgreementDialog open={showAgreement} setUserAgreementDialog={setShowAgreement} action={updateUserAgreementResponse} agreement={agreeMentData[0]?.tecoUserAgreement?.agreementText} close={() => {
      showHideModal(false);

    }} />
  }
  return (
    <div>
      <Modal
        // ariaHideApp={false}
        isOpen={show}
        // onAfterOpen={}
        onRequestClose={() => {
          showHideModal(false);
        }}
        shouldCloseOnOverlayClick={true}
        style={customStyles}
        contentLabel="Example Modal"
      >
        <div className="popheader SchedulecalanderModal">
          <h3>
            {`${viewOnly ? 'View ' : `${skipWeeks ? 'Set upcoming ' : 'Set '}`
              } availability`}
          </h3>
          <div className="calendarModal-subHeader">
            {/* {firstTime ? (
              <p>
                Set your availability for the next 2 weeks. You can adjust
                availability in the settings page.
              </p>
            ) : null} */}
            {navigationAllowed && (
              <div className="monthSelector">

                {(prevClicked && skipWeeks) || calStartFlag ? (
                  ''
                ) : (
                  <span
                    onClick={() => {
                      calendarNavigation('prev');
                    }}
                  >
                    <LeftArrow />
                  </span>
                )}
                {`${calStartFlag ? format(new Date(), 'MMMM') + ` ` : prevMonth + ` `}`}
                {`${calStartFlag ? format(new Date(), 'dd') + ` - ${nextMonth}` + ` ` : `${prevDate} - ${nextMonth} `}`}
                {`${nextDate}`}
                {(nextClicked && !skipWeeks) || endDateReached ? (
                  ''
                ) : (
                  <span
                    onClick={() => {
                      calendarNavigation('next');
                    }}
                  >
                    <RightArrow />
                  </span>
                )}
              </div>
            )}
          </div>
          {/* <div>
            <span>
              <input type="checkbox" />
            </span>
            Duplicate schedule for next week
          </div>*/}

          <span className="popheaderspan">
            <button
              className="transpBtn"
              onClick={() => {
                showHideModal(false);
              }}
            >
              {<CloseIcon />}
            </button>
          </span>
        </div>
        <div class="content">
          <div className="calanderboxWrapper popcalendar">
            <FullCalendar
              ref={calendarRef}
              plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin]}
              slotLabelFormat={{
                hour: 'numeric',
                minute: '2-digit',
                omitZeroMinute: false,
                meridiem: 'short',
              }}
              eventBackgroundColor="#EAF5FF"
              eventBorderColor="transparent"
              eventTextColor="#1367B2"
              slotMinTime="06:00:00"
              slotMaxTime="23:00:00"
              initialView="timeGridWeek"
              editable={editable}
              selectable={!viewOnly}
              dayMaxEvents={false}
              allDaySlot={false}
              headerToolbar={false}
              dayHeaderFormat={{
                weekday: 'long',
              }}
              dayHeaderContent={renderHeaderDates}
              dayCellDidMount={handleDayCellDidMount}
              selectOverlap={false}
              eventOverlap={false}
              weekends={true}
              height="auto"
              events={meetingsArray}
              select={handleDateSelect}
              eventContent={renderEventContent}
              eventResize={editMeeting}
              eventDrop={editMeeting}
              eventResizableFromStart={true}
              validRange={{
                start: format(new Date(), 'yyyy-MM-dd'),
                end: format(addDays(getEndDateLimit(), 1), 'yyyy-MM-dd') // Add 1 day to include the end date
              }}
              eventAllow={preventSlotBeforeStartTime}
              selectAllow={(selectInfo) => !isDateBeyondLimit(selectInfo.start)}
            />
          </div>
        </div>
        <div className="popfooter">
          <span className="err">{apiResponse}</span>
          {!viewOnly && (
            <button
              onClick={() => {
                showHideModal(false);
              }}
              className="btn cancelbtn"
            >
              Cancel
            </button>
          )}
          {!viewOnly && (
            <button
              disabled={meetingData.length === 0 || saving}
              onClick={() => {
                createSlot();
              }}
              className={`btn ${meetingData.length === 0 || saving
                ? ' disabled-roundedbtn'
                : 'blueroundedbtn'
                }`}
            >
              Save
            </button>
          )}
          {viewOnly && (
            <button
              onClick={() => {
                showHideModal(false);
              }}
              className="btn blueroundedbtn"
            >
              Close
            </button>
          )}
        </div>
        {showDeleteConfirm && (
          <Modal
            isOpen={showDeleteConfirm}
            onRequestClose={() => {
              setShowDeleteConfirm(false);
              setEventToDelete(null);
              setEventLocalCaId(null);
            }}
            style={{
              content: {
                top: '50%',
                left: '50%',
                right: 'auto',
                bottom: 'auto',
                marginRight: '-50%',
                transform: 'translate(-50%, -50%)',
                maxWidth: '400px',
                padding: '30px',
                borderRadius: '10px',
              },
              overlay: {
                position: 'fixed',
                top: 0,
                left: 0,
                right: 0,
                bottom: 0,
                backgroundColor: 'rgba(0, 0, 0, 0.5)',
                zIndex: 1000,
              },
            }}
          >
            <h4 style={{ marginTop: 0 }}>Confirm Delete</h4>
            <p style={{ marginBottom: '20px', color: '#666' }}>
              Are you sure you want to delete this event?
            </p>
            <div style={{ display: 'flex', gap: '10px', justifyContent: 'flex-end' }}>
              <button
                onClick={() => {
                  setShowDeleteConfirm(false);
                  setEventToDelete(null);
                  setEventLocalCaId(null);
                }}
                className="btn cancelbtn"
              >
                No
              </button>
              <button
                onClick={() => {
                  handleDeleteEvent(eventToDelete, eventLocalCaId);

                  setShowDeleteConfirm(false);
                  setEventToDelete(null);
                  setEventLocalCaId(null);
                }}
                className="btn"
                style={{
                  backgroundColor: '#dc3545',
                  color: 'white',
                  borderColor: '#dc3545',
                }}
              >
                Yes
              </button>
            </div>
          </Modal>
        )}
      </Modal>
    </div>
  );
}

export default CalendarModal;
